// removed by extract-text-webpack-plugin
module.exports = {"grey-cross":"OjSYq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.scss
// module id = ./src/components/Prompt/BankDetailsVerified/BankDetailsVerifiedContent.scss
// module chunks = 5